<template>
  <div class="Tip">
    <header class="Tip-img Intrinsic-wrapper Intrinsic-wrapper--2x3">
      <!-- <img 
        class="Intrinsic-item"
        :src="'./static/images/' + imgFileName" alt="Ideum multitouch tables used for trade shows, events and interactive development."> -->
      <img
        :data-src="'./static/images/' + imgFileName"
        class="Intrinsic-item lazyload"
        alt="Ideum multitouch tables used for trade shows, events and interactive development.">
    </header>
    <main class="Tip-wrapper">
      <slot name="Tip-title"/>
      <slot name="Tip-body"/>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    imgFileName: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Tip {
  background-color: $colorWhite;
  box-shadow: 0 3px 30px rgba(0, 0, 0, .1);
  color: $colorPlum;
  text-align: center;
  width: 100%;
  height: 100%;
}

.Tip-body {
  margin: 0;
}

.Tip-img {
  position: relative;
  &::after {
    background-color: $colorPlum;
    content: '';
    opacity: .5;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.Tip-title {
  font-family: 'Roboto';
  font-size: 1.5em;
  font-weight: 400;
  margin: 0 0 1.5em 0;
  position: relative;
  &::after {
    background-color: $colorEmerald;
    content: '';
    margin: 0 auto;
    position: absolute;
    right: 0;
    bottom: -.75em;
    left: 0;
    width: 25%;
    height: 4px;
  }
}

.Tip-wrapper {
  padding: 3em 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Tip.vue